import { FunctionComponent, useEffect, useState } from 'react'
import Title from '@/components/_custom/Title/title'
import styles from './deactiveNotificationAccount.module.scss'
import EmailData from '../emailData'
import validator from 'validator'
import { useTranslation } from 'react-i18next'
import UserInput from '@/components/_custom/UserInput/userInput'
import { EmailUser } from '@/types/EmailHandlerType'
import ButtonText from '@/components/_custom/Buttons/ButtonText/ButtonText'
import { useLazyQuery } from '@apollo/client'
import { EMAIL_EXISTS } from '@/modules/API/software/emailHandler'
import ConfirmDeactiveNotificationAccountDialog from './Dialog/confirmDeactiveNotificationAccountDialog'

const DeactiveNotificationAccount: FunctionComponent = () => {
    const { t } = useTranslation()

    const [emailDeactivation, setEmailDeactivation] = useState<string>('')
    const [emailDeactivationData, setEmailDeactivationData] = useState<EmailUser>()

    const [isConfirmDialogOpen, setConfirmDialogOpen] = useState<boolean>(false)

    const [getEmailExists, { loading: loadingEmailExist, data: dataEmailExist, error: errorEmailExist }] = useLazyQuery(
        EMAIL_EXISTS,
        {
            variables: {
                email: emailDeactivation
            }
        }
    )

    useEffect(() => {
        if (dataEmailExist) {
            setEmailDeactivationData(dataEmailExist.emailExists)
        }
    }, [dataEmailExist])

    useEffect(() => {
        if (errorEmailExist) {
            setEmailDeactivationData(undefined)
        }
    }, [errorEmailExist])

    useEffect(() => {
        if (validator.isEmail(emailDeactivation)) getEmailExists()
    }, [emailDeactivation])

    return (
        <div className={styles.Form}>
            <Title text={t('deactivateNotificationAccount')} className={styles.Title} />
            <div className={styles.InputContainer}>
                <div className={styles.Input}>
                    <UserInput
                        value={emailDeactivation}
                        setValue={setEmailDeactivation}
                        required={true}
                        label={t('email')}
                        className={styles.UserInput}
                        type={'text'}
                        unallowedCharacters={'email'}
                        verify={'email'}
                    />
                    <EmailData data={emailDeactivationData} loading={loadingEmailExist} />
                </div>
                <ButtonText
                    text={t('deactivation')}
                    onClick={() => setConfirmDialogOpen(true)}
                    className={styles.Button}
                    disabled={!emailDeactivationData || loadingEmailExist || !validator.isEmail(emailDeactivation)}
                />
            </div>
            <ConfirmDeactiveNotificationAccountDialog
                open={isConfirmDialogOpen}
                emailDeactivationData={emailDeactivationData}
                handleClose={() => setConfirmDialogOpen(false)}
                setEmail={setEmailDeactivation}
                setEmailDeactivationData={setEmailDeactivationData}
                email={emailDeactivation}
            />
        </div>
    )
}

export default DeactiveNotificationAccount
